// src/plugins/inactivityTimer.js
import cookies from 'vue-cookies'
export default {
  install(Vue) {
    let timer;
    const INACTIVITY_THRESHOLD = 600000; // 10 minutes in milliseconds
    const LOGIN_PAGE_URL = '/publicIndex'; // 返回首页

    function resetTimer() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        // 实现退出会话逻辑
        localStorage.removeItem('authToken');
        cookies.remove("userId")
        cookies.remove("token")
        cookies.remove("userInfo")
        cookies.remove("isLegal")
        window.location.href = LOGIN_PAGE_URL;
      }, INACTIVITY_THRESHOLD);
    }

    function startListening() {
      document.addEventListener('mousemove', resetTimer);
      document.addEventListener('keypress', resetTimer);
      document.addEventListener('click', resetTimer);
      document.addEventListener('scroll', resetTimer);
      // 可以添加更多事件监听器，例如 touchstart, touchmove 等

      // 初始化定时器
      resetTimer();
    }

    function stopListening() {
      document.removeEventListener('mousemove', resetTimer);
      document.removeEventListener('keypress', resetTimer);
      document.removeEventListener('click', resetTimer);
      document.removeEventListener('scroll', resetTimer);
      clearTimeout(timer);
    }

    Vue.prototype.$startInactivityTimer = startListening;
    Vue.prototype.$stopInactivityTimer = stopListening;

    // 在 Vue 实例创建时自动启动监听
    Vue.mixin({
      mounted() {
        this.$startInactivityTimer();
      },
      beforeDestroy() {
        this.$stopInactivityTimer();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/inactivityTimer.js